import { makeAutoObservable, autorun, action, runInAction } from 'mobx'
import { restaurantConfig, cartMobx } from 'restaurant'
import { memberMobx, buyTogetherMobx, multiPersonOrderingMobx } from '@mobxStore'
import { getCommonResourcesPath } from '@env'
import { getVisitorInfo, setVisitorInfo, getPlatform } from '@utils'
import { BarrageController } from '@ctrls/index'
import { sortBy } from '@dt/fe-utils/dist/lodash'

/** 用户过期时间（30分钟） */
const expireTime = 1800000

/** 用户点餐状态的枚举值 初始化，点单中，已完成 */
export enum TEnumUserStatus { init = 'init', menu = 'menu', success = 'success' }

const userInfoToPersonInfo = (type: 'visitor' | 'member' | 'user', info: any) => {
  if (type === 'visitor') {
    return {
      personId: info?.id,
      nickName: info?.name,
      avatar: info?.avatar,
      personType: 'visitor',
    } as ISyncUser
  }

  return {
    personId: bo === 'cn' ? (String(info?.memberId) || info?.visitorId) : (info?.visitorId || String(info?.memberId)),
    memberId: info?.memberId,
    nickName: info?.nickName || info?.name || 'Guest',
    avatar: info?.avatarUrl || info?.avatar,
    personType: info?.type,
  } as ISyncUser
}
class MultiPerson {
  constructor () {
    makeAutoObservable(this, {
      init: action,
      setCurrentPersonInfo: action.bound
    })
  }
  // 修改头像
  isChangeAvatar: boolean = true
  // 关于游客初始化
  _data: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']
  newRandomImg: any = ''

  /** 是否初始化 */
  isInit = false

  /** 当前点餐人信息 */
  currentPersonInfo = {} as ISyncUser

  /** 当前点餐人列表 map */
  multiPersonMap = {} as ISyncUserMap

  personCntInfo: { cnt: number; kids?: number }

  // 初始化人员
  info = this.getInfo()

  /** 点餐人员列表 */
  get multiPersonList () {
    if (this.multiPersonMap) {
      const persons = Object.values(this.multiPersonMap)
      return persons.length
        ? sortBy(persons, (person) => person.createTime)
        : []
    }
    return []
  }
  defaultName: string = ''

  /** 获取活跃的点餐人员 (加入超过30分钟就不活跃了) */
  get activePersons () {
    if (this.multiPersonMap) {
      const persons = Object.values(this.multiPersonMap)
      return persons.length
        ? sortBy(
          persons.filter(
            (person) => person.createTime + expireTime >= Date.now()
          ),
          (person) => person.createTime
        )
        : []
    }
    return []
  }

  /** 是否是多人点餐 */
  get isMultiPerson () {
    return this.multiPersonMap && Object.keys(this.multiPersonMap).length > 1
  }

  /** 点餐人员初始化 */
  init (multiPersonMap: ISyncUserMap, person: any) {
    const { isWeixin, isAlipay } = getPlatform()
    const avatarGet = getVisitorInfo()
    if ((isWeixin || isAlipay) && !memberMobx.isLogin) {
      return
    }
    if (multiPersonMap) {
      this.multiPersonMap = {
        ...this.multiPersonMap,
        ...multiPersonMap,
      }
    }
    !avatarGet && this.generateCharacter()
    this.listenPersonInfoChange()
    this.isInit = true
    this.personCntInfo = person
    if (Config.buyTogetherId) {
      const isMapEmpty = !Object.keys(multiPersonMap)?.length
      if (!Config?.btRoomInit && isMapEmpty) {
        return
      }

      this.initBTPersonInfo()
      if (multiPersonMap) {
        this.multiPersonMap = {
          ...this.multiPersonMap,
          ...multiPersonMap,
        }
      }

      // const personId = this.currentPersonInfo?.personId
      // if (this.currentPersonInfo.isOwner && !this.currentPersonInfo.ordersId && this.multiPersonMap[personId]?.ordersId) {
      //   const info = {
      //     ...this.multiPersonMap[personId],
      //     ...this.currentPersonInfo,
      //     ordersId: this.currentPersonInfo.ordersId || this.multiPersonMap[personId].ordersId
      //   }
      //   setTimeout(() => {
      //     this.setCurrentPersonInfo(info)
      //   }, 2000)
      // }
    }
  }

  setOrderPerson (person: { cnt: number; kids?: number }) {
    if (person && typeof person === 'object') {
      cartMobx.setPerson(person.cnt || 0, true)
      cartMobx.setKidsPerson(person.kids || 0)
    } else {
      // cartMobx.setPerson(Object.keys(multiPersonMap).length || 1, true)
    }
  }

  /** 监听点餐人变化 */
  listenPersonInfoChange () {
    multiPersonOrderingMobx.onUserChange((data) => {
      runInAction(() => {
        const users = data?.user
        const syncCnt = data?.syncCnt
        if (data.operation.action === 'del') {
          const key = data.operation.user.personId
          delete this.multiPersonMap[key]
        }
        if (users) {
          for (let key in users) {
            // 有新人加入，弹幕通知
            if (!this.multiPersonMap[key] && key !== this.currentPersonInfo?.personId) {
              if (!Config.buyTogetherId) {
                BarrageController.show(
                  i18n.t('multi.joinInMultiOrder', { name: users[key].nickName }), users[key].avatar, syncCnt
                )
                this.multiPersonMap[key] = users[key]
              }
            }
            if (Config.buyTogetherId) {
              this.multiPersonMap[key] = users[key]
            }
          }
          this.personCntInfo = data.person
          this.setOrderPerson(data.person)
        }
      })
    })
  }

  /** 更新当前点餐用户信息 */
  setCurrentPersonInfo (personInfo: ISyncUser) {
    const currentPerson = this.getCurrentPersonInfo()
    let avatar: any = ''
    let nickName: string = personInfo.nickName || this.currentPersonInfo.nickName || currentPerson.nickName
    if (!personInfo.avatar && !this.currentPersonInfo.avatar && !currentPerson.avatar) {
      let infoImg = this.generateCharacter()
      avatar = infoImg.avatar
      nickName = nickName || infoImg.name
    } else {
      avatar = personInfo.avatar || this.currentPersonInfo.avatar || currentPerson.avatar
      // nickName = personInfo.nickName || this.currentPersonInfo.nickName || currentPerson.nickName
    }
    let info = {
      ...this.currentPersonInfo,
      ...currentPerson,
      ...personInfo,
      avatar,
      nickName,
      createTime: this.multiPersonMap[personInfo.personId]?.createTime || Date.now(),
    }
    // 拼单需要插入地址
    if (Config.buyTogetherId) {
      info = {
        status: buyTogetherMobx.useStatus,
        ...info
      }
      if (currentPerson.isOwner) {
        info = {
          ...info,
          isOwner: true,
          address: buyTogetherMobx.addressInfo,
          eatType: buyTogetherMobx.eatType,
          ordersId: info.ordersId || this.multiPersonMap[personInfo.personId]?.ordersId
        }
      }
    }
    // 当创建时间已经过去30分钟，更新一下
    if (info.createTime < Date.now() - expireTime) {
      info.createTime = Date.now()
    }

    const userMap = multiPersonOrderingMobx.multiPersonData?.user
    if (buyTogetherMobx.getOwner === info.personId || userMap?.[buyTogetherMobx.getOwner]?.personId || restaurantConfig.codeType === 'table') {
      multiPersonOrderingMobx.addPerson(info)
      this.multiPersonMap[personInfo.personId] = info
    }
    // multiPersonOrderingMobx.addPerson(info)
    this.currentPersonInfo = info
    if (restaurantConfig.codeType === 'table') {
      this.setOrderPerson(this.personCntInfo)
    }
  }

  async delCurrentPersonInfo () {
    const currentPerson = this.getCurrentPersonInfo()

    if (currentPerson.personId === buyTogetherMobx.getOwner) {
      await multiPersonOrderingMobx.clearMultiCart()
      await multiPersonOrderingMobx.delMultiRoom()
      return
    }

    const _cartItems = cartMobx.cartItems.map(item => {
      if (item.addUserId !== currentPerson.personId) {
        return item
      }
    }).filter(item => !!item)
    // cartMobx.remove(_cartItems)

    multiPersonOrderingMobx.delPerson(currentPerson)
    delete this.multiPersonMap[currentPerson.personId]
    this.currentPersonInfo = {} as ISyncUser
    setTimeout(() => {
      cartMobx.setCartItems(_cartItems)
    }, 300)
  }

  /** 设置当前点餐用户的点餐状态 */
  setCurrentPersonStatus (status: TPersonStatus) {
    let info = {
      ...this.currentPersonInfo,
      status
    }
    multiPersonOrderingMobx.addPerson(info)
  }

  /** 设置当前拼单的地址 */
  setCurrentPersonAddress (address: any) {
    // 拼单需要插入地址
    if (Config.buyTogetherId) {
      if (this.currentPersonInfo.isOwner && buyTogetherMobx.eatType === 'delivery') {
        const info = {
          ...this.currentPersonInfo,
          status: buyTogetherMobx.useStatus,
          address
        }
        multiPersonOrderingMobx.addPerson(info)
      }
    }
  }

  clearCurrentPersonInfo () {
    this.currentPersonInfo = {} as ISyncUser
  }

  clearMultiPersonMap () {
    this.multiPersonMap = {}
  }

  /** 获取当前用户信息 */
  getCurrentPersonInfo () {
    let info = this.currentPersonInfo as ISyncUser
    const visitorInfo = getVisitorInfo()
    if (!this.currentPersonInfo?.personId) {
      if (memberMobx.isLogin) {
        info = userInfoToPersonInfo('member', memberMobx.memberInfo.type === 'member' ? memberMobx.memberInfo : { ...memberMobx.memberInfo, ...visitorInfo })
      } else {
        if (visitorInfo) {
          info = userInfoToPersonInfo('visitor', visitorInfo)
        }
      }
    }
    return { ...info, isOwner: info.personId === buyTogetherMobx.getOwner }
  }
  generatePicUrl (personList: Array<any>) {
    const userName = personList.map((item) => {
      return item.avatar
    })
    const set = new Set(userName)
    const otherImg = this._data.find((e) => {
      return !set.has(`${getCommonResourcesPath('image')}/avatar/avatar${this._data[e]}.png`)
    })

    this.newRandomImg = otherImg ? `${getCommonResourcesPath('image')}/avatar/avatar${this._data[otherImg]}.png` : ''
  }
  getInfo () {
    const info = getVisitorInfo()

    return info || {
      name: '',
      avatar: '',
      isSave: 1,
    }
  }
  // 生成随机名字
  getRandomName () {
    return `${i18n.t('mkt.login.guest')}${Math.random().toString().substring(2, 6)}`
  }
  // 自动生成头像和名称
  generateCharacter () {
    this.isChangeAvatar && this.generatePicUrl(this.activePersons)
    const RandomName = this.getRandomName()
    setVisitorInfo({
      ...this.info,
      avatar: this.isChangeAvatar ? this.newRandomImg : this.info.avatar,
      name: RandomName || '',
    })
    return {
      avatar: this.isChangeAvatar ? this.newRandomImg : this.info.avatar,
      name: RandomName || ''
    }
    // const visitorInfo = this.getInfo()
    // console.log(visitorInfo, '头像👮‍♀️')
    // this.setCurrentPersonInfo({
    //   personId: visitorInfo.id,
    //   nickName: visitorInfo.name || '',
    //   avatar: visitorInfo.avatar,
    //   personType: 'visitor',
    // })
  }

  initPersonInfo () {
    if (!this.currentPersonInfo?.personId && this.isInit) {
      // 会员登录
      if (memberMobx.memberInfo.type === 'member' && memberMobx.isLogin) {
        this.setCurrentPersonInfo(userInfoToPersonInfo('member', memberMobx.memberInfo))
      } else {
        const info = getVisitorInfo()
        if (info) {
          this.setCurrentPersonInfo(userInfoToPersonInfo('visitor', info))
        }
      }
    }
  }

  initBTPersonInfo () {
    if (!this.currentPersonInfo?.personId && memberMobx.isLogin) {
      // 会员登录
      const memberInfo = userInfoToPersonInfo('member', memberMobx.memberInfo)
      memberInfo.personId = String(memberMobx.memberInfo?.memberId)
      this.setCurrentPersonInfo(memberInfo)
    }
  }
}
const MultiPersonMobx = new MultiPerson()

setTimeout(() => {
  autorun(async () => {
    if (Config.codeType !== 'table') {
      return
    }
    // console.log('autorun', memberMobx.memberInfo, MultiPersonMobx.currentPersonInfo)
    // 生成多人点餐用户
    MultiPersonMobx.initPersonInfo()
  })
})

export default MultiPersonMobx
